<template>
	<div id="report">
		<Header :title="strings.report.title">{{ strings.report.header }}</Header>

		<v-card class="mx-auto">
			<v-card-text>
				<v-row>
					<v-col cols="12" align="center">
						<v-progress-circular
							v-if="submitting"
							color="ocean"
							size="70"
							width="6"
							indeterminate
						/>
						<v-icon
							v-else-if="hasError"
							class="circled"
							color="rust-red"
							size="70"
							>fa-exclamation</v-icon
						>
						<v-icon v-else color="ocean" size="70">fa-thumbs-up</v-icon>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" align="center">
						<span
							v-if="hasError"
							class="title rust-red--text text--darken-1"
							v-text="strings.report.failure"
						/>
						<span v-else class="title">{{
							submitting ? strings.report.submitting : strings.report.success
						}}</span>
					</v-col>
				</v-row>
			</v-card-text>

			<v-card-actions v-if="!submitting">
				<v-row>
					<v-col v-if="hasError" cols="12" align="center">
						<v-btn
							color="ocean"
							class="white--text"
							min-width="150"
							large
							@click="retry"
							>Retry</v-btn
						>
					</v-col>
					<v-col v-else cols="12" align="center">
						<v-btn color="ocean darken-1" outlined @click="exit(true)">{{
							strings.report.new
						}}</v-btn>
						<v-btn color="warm-blue" outlined @click="exit(false)">{{
							strings.report.home
						}}</v-btn>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</div>
</template>

<style lang="scss" scoped>
.circled {
	min-width: 120px;
	min-height: 120px;
	padding: 20px;
	border-radius: 50%;
	border: 4px solid;
}
</style>

<script>
import { mapActions } from "vuex";

import strings from "@/utils/strings";
import confetti from "@/assets/js/confetti";
import { APIAuthError } from "@/utils/http";

import Header from "../shared/Header";

export default {
	components: { Header },

	data: () => ({
		strings,

		submitting: true,
		hasError: false,
	}),

	async mounted() {
		await this.submitReport();
	},

	methods: {
		...mapActions({
			resetController: "controller/resetState",
			resetDevices: "devices/resetState",
			doSubmitReport: "install/submitReport",
		}),

		async retry() {
			this.hasError = false;
			await this.submitReport();
		},

		async submitReport() {
			this.submitting = true;

			try {
				await this.doSubmitReport();
				confetti.start(600);
			} catch (e) {
				if (e instanceof APIAuthError) throw e;
				this.hasError = true;
			} finally {
				this.submitting = false;
			}
		},

		async exit(newSession) {
			// Reset any transient data from install session
			await this.resetController();
			await this.resetDevices();

			if (newSession) {
				// De-select current system
				this.$store.commit("session/setSystemId", null);
				// After reseting state, rebuild current install session
				await this.$store.dispatch("communities/load");

				// And start over from (almost) the beginning
				// Will automatically skip community selection since we're keeping the existing community the same.
				return this.$root.$router.push({ name: "Install" });
			} else {
				return this.$root.$router.push({ name: "Home" });
			}
		},
	},
};
</script>
